import { render, staticRenderFns } from "./SelectSubject.vue?vue&type=template&id=97b57c04&"
import script from "./SelectSubject.vue?vue&type=script&lang=js&"
export * from "./SelectSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97b57c04')) {
      api.createRecord('97b57c04', component.options)
    } else {
      api.reload('97b57c04', component.options)
    }
    module.hot.accept("./SelectSubject.vue?vue&type=template&id=97b57c04&", function () {
      api.rerender('97b57c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/components/SelectSubject.vue"
export default component.exports